import { AISearchHistoryEntry } from './aiSearchHistory';

const csvCell = (value: string | number): string => {
  const text = String(value);
  // Keep user questions and generated content from becoming spreadsheet formulas.
  const safe = /^[\s]*[=+@-]|^[\t\r\n]/.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
};

export const buildAISearchHistoryCsv = (entries: AISearchHistoryEntry[]): string => {
  const headers = [
    'Session ID', 'Question', 'Flow', 'Started at (UTC)', 'Completed at (UTC)', 'Duration (seconds)',
    'Status', 'Document count', 'Documents (JSON)', 'Answer', 'Response (JSON)', 'Error', 'Index', 'Filters (JSON)',
  ];
  const rows = entries.map(entry => [
    entry.sessionId, entry.searchText, entry.flowId, new Date(entry.startedAt).toISOString(),
    entry.completedAt === null ? '' : new Date(entry.completedAt).toISOString(),
    entry.durationMs === null ? '' : entry.durationMs / 1000,
    entry.status, new Set(entry.references.map(ref => ref.id)).size, JSON.stringify(entry.references),
    entry.report?.scientific_summary.body_paragraphs.map(paragraph => paragraph.narrative_text).join('\n\n') ?? '',
    entry.report ? JSON.stringify(entry.report) : '', entry.error ?? '', entry.indexName, JSON.stringify(entry.filters),
  ]);
  return '\uFEFF' + [headers, ...rows].map(row => row.map(csvCell).join(',')).join('\r\n');
};
